import Tag from '../../../../components/Display/Tag';
import { CONSTANT } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';
import { ChevronUp } from '@primeicons/react/chevron-up';
import { ChevronDown } from '@primeicons/react/chevron-down';
import { Star } from 'lucide-react';
import styles from '../../cards.module.scss';

function ProjectItem({ project, handleClickProject, onChange, layout, currentOrder }) {
  // Fonction pour monter ordre
  const handleMoveUp = (e) => {
    e.stopPropagation();
    onChange(project, -1);
  };

  // Fonction pour descendre ordre
  const handleMoveDown = (e) => {
    e.stopPropagation();
    onChange(project, 1);
  };

  return (
    <div
      className={`${styles.projectCard} ${layout === 'grid' ? styles.projectCardGrid : ''}`}
      onClick={handleClickProject}>
      <img
        className={styles.projectImage}
        src={project.main_image?.file ? project.main_image?.file : getImage('img-ph.png')}
        alt={project.main_image?.label ? project.main_image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{project.title}</p>
          <span className={styles.subtitle}>{project.place_name}</span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={CONSTANT.prna.statusTypes.find((s) => s.value === project.state)}
            rounded
            className="w-fit"
          />
          <Tag
            tag={{
              label: project.is_highlight && 'Projet mis en avant',
              icon: Star,
              bgColor: project.is_highlight && 'bg-purple-800'
            }}
            rounded
          />
          <Tag
            tag={{
              label: `${project.circumstances.length} image${project.circumstances.length > 1 ? 's' : ''}`,
              bgColor: 'bg-slate-700'
            }}
            rounded
          />
        </div>
      </div>
      <ButtonGroup className={styles.buttonList}>
        <Button
          variant="outlined"
          severity="primary"
          text
          raised
          iconOnly
          className="rounded-full"
          onClick={handleMoveUp}>
          <ChevronUp />
        </Button>
        <p>{currentOrder + 1}</p>
        <Button
          variant="outlined"
          severity="primary"
          iconOnly
          text
          raised
          className="rounded-full"
          onClick={handleMoveDown}>
          <ChevronDown />
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default ProjectItem;
